module.exports = __webpack_public_path__ + "img/70.3.TP.e6fcd95a.png";